import { Link, Navigate, useOutlet } from "react-router-dom";
import { useAuth } from "hooks/useAuth";
import { AppBar } from "components/AppBar";

export const ProtectedLayout = () => {
  const { user } = useAuth();
  const outlet = useOutlet();

  if (!user) {
    return <Navigate to="/" />;
  }

  return (
    <div>
      <AppBar
        pages={[
          { label: "Tenants", path: "tenants", visible: user.clientId == 1 },
          { label: "Settings", path: "settings", visible: user.clientId == 1 },
          { label: "Reports", path: "reports", visible: user.clientId != 1 },
        ]}
      />
      {outlet}
    </div>
  );
};
